
import { Comment } from '../types/comment';

interface Post {
  id: string;
  title: string;
  content: string;
  media?: { 
    type: string; 
    url: string;
    thumbnailUrl?: string;
  }[];
  author?: {
    name: string;
    avatar?: string;
  };
  timestamp: Date;
  platform: string;
}

export const createPostFromComment = (comment: Comment): Post | null => {
  if (!comment) return null;
  
  return {
    id: comment.postId,
    title: comment.videoTitle || '',
    content: '',
    media: comment.videoId ? [
      {
        type: 'video',
        url: `https://www.youtube.com/watch?v=${comment.videoId}`,
        thumbnailUrl: `https://img.youtube.com/vi/${comment.videoId}/hqdefault.jpg`
      }
    ] : [],
    author: {
      name: comment.author.name,
      avatar: comment.author.avatar,
    },
    timestamp: comment.timestamp,
    platform: comment.platform,
  };
};

export const formatTime = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  
  if (diffInSeconds < 60) {
    return `il y a ${diffInSeconds} secondes`;
  }
  
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `il y a ${diffInMinutes} minutes`;
  }
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `il y a ${diffInHours} heures`;
  }
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) {
    return `il y a ${diffInDays} jours`;
  }
  
  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    return `il y a ${diffInMonths} mois`;
  }
  
  const diffInYears = Math.floor(diffInMonths / 12);
  return `il y a ${diffInYears} ans`;
};
